import Image from "next/image";

type Props = {
  isSelected?: boolean;
  userAmount?: number;
  totalPrice?: number;
  tokenTicker: string;
};

export const TokenCard = (props: Props) => {
  return (
    <>
      <div
        className="flex h-fit w-full items-center gap-[14px] px-[20px] py-[7px]"
        style={{
          backgroundColor: props.isSelected ? "#F0F5FF" : "white",
        }}
      >
        <div className="relative h-[50px] w-[50px]">
          <Image
            src={`/assets/${props.tokenTicker}.png`}
            layout="fill"
            objectFit="cover"
            alt="fandIcon"
          />
        </div>
        <div className="flex h-fit flex-grow flex-col items-start">
          <div className="flex items-center gap-[3px]">
            <p className="text-[17px] font-bold leading-[26px]">
              {props.userAmount?.toLocaleString()}
            </p>
            <p className="text-[15px] leading-[20px]">{props.tokenTicker}</p>
          </div>
          <p className="text-[13px] leading-[20px] text-[#00000073]">
            {`(=$${props.totalPrice ? props.totalPrice.toLocaleString() : 0})`}
          </p>
        </div>
      </div>
    </>
  );
};
